import React from 'react';
import { useApp } from '../../context/AppContext.tsx';
import { Phone, Mail, MessageCircle } from 'lucide-react';
import { buildWaUrl, formatPhoneTel } from '../../lib/contactUtils.ts';

export default function TopBar() {
  const { settings } = useApp();

  if (!settings || !settings.topBarEnabled || !settings.topBarText) {
    return null;
  }

  const topBarWaText = settings.topBarCtaText || 'WA Fast Response';
  const topBarMsg = settings.topBarWaMessage || 'Halo Admin, saya tertarik dengan layanan Anda.';
  const waUrl = buildWaUrl(
    settings.contact.whatsappNumber,
    topBarMsg
  );
  const phoneTel = formatPhoneTel(settings.contact.phone);

  // Clean any star symbols (⭐, 🌟, ✨, ★, ☆, etc.) or decorative icon prefix
  const cleanTopBarText = (settings.topBarText || '')
    .replace(/[⭐🌟✨★☆*]/g, '')
    .replace(/^[\s🌿🔥•-]+\s*/, '')
    .trim();

  return (
    <div
      id="site-topbar"
      className="bg-slate-950 text-slate-200 text-xs py-1.5 sm:py-2 px-3 sm:px-6 lg:px-8 border-b border-slate-800/80 transition-colors"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-2 sm:gap-4">
        {/* Left: Announcement / Promo Text */}
        <div className="flex items-center gap-2 min-w-0 font-medium text-[11px] sm:text-xs">
          <span className="truncate max-w-[220px] xs:max-w-xs sm:max-w-md md:max-w-xl text-slate-300 font-medium">
            {cleanTopBarText || settings.topBarText}
          </span>
        </div>

        {/* Right: Contact Links & WhatsApp Fast Action */}
        <div className="flex items-center gap-2 sm:gap-4 shrink-0 text-slate-300">
          {settings.contact.phone && (
            <a
              id="topbar-phone-link"
              href={`tel:${phoneTel}`}
              className="hidden md:flex items-center gap-1.5 text-[11px] sm:text-xs hover:text-white transition-colors"
              title={`Telepon Resmi: ${settings.contact.phone}`}
            >
              <Phone className="w-3 h-3 text-emerald-400" />
              <span>{settings.contact.phone}</span>
            </a>
          )}
          {settings.contact.email && (
            <a
              id="topbar-email-link"
              href={`mailto:${settings.contact.email}`}
              className="hidden lg:flex items-center gap-1.5 text-[11px] sm:text-xs hover:text-white transition-colors"
              title="Email Resmi"
            >
              <Mail className="w-3 h-3 text-emerald-400" />
              <span>{settings.contact.email}</span>
            </a>
          )}
          {settings.contact.whatsappNumber && (
            <a
              id="topbar-whatsapp-btn"
              href={waUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 bg-emerald-600 hover:bg-emerald-500 text-white px-2.5 py-1 rounded-full text-[10px] sm:text-xs font-bold transition-all shadow-xs shrink-0 cursor-pointer active:scale-95"
            >
              <MessageCircle className="w-3 h-3" />
              <span>{topBarWaText}</span>
            </a>
          )}
        </div>
      </div>
    </div>
  );
}

